import React from 'react';
import map from 'lodash/map';
import b_ from 'b_';

import {TargetingsProps} from 'client/common/components/audience-settings/types';
import {getStandardGeoLabels} from 'client/common/components/audience-settings/helpers';
import {TargetingOptions} from 'client/common/utils/audience';

const b = b_.with('audience-settings');

export function AudienceNoTargeting(
    props: Pick<TargetingsProps, 'categories' | 'boxType' | 'request'>
) {
    const {request, categories, boxType} = props;

    const targetingOptions = TargetingOptions.getTargetingOptions({
        categories,
        boxType,
        country: undefined
    });

    const {geo} = TargetingOptions.getTargetingValues(request);
    const defaultGeo = map(targetingOptions.geo.slice(0, 1), 'value');

    const geoLabel = getStandardGeoLabels(targetingOptions.geo, geo || defaultGeo);

    return (
        <div className={b('targeting-labels')}>
            <div className={b('targeting-label')}>{geoLabel}</div>
        </div>
    );
}
